module.exports = __webpack_public_path__ + "img/77338.f88f5c3b.svg";